import React from "react";
import VectorGraphPage from "./components/VectorGraphPage";
import "./App.css";

function App() 
{
  return (
    <div className="App">
      <VectorGraphPage />
    </div>
  );
}

export default App;

